/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import DeleteConfirmPopover from '../../../../../../../components/DeleteConfirmPopover';
import { EntityEquipmentType } from '../../../../../../../models/core/entities.type';
import theme from '../../../../../../../theme';

type DataViewActionProps = {
  item: EntityEquipmentType;
  confirmActionResult(items: EntityEquipmentType | null, action: string, confirmed: boolean): void;
};

export default function EquipmentFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Editar">
        <ActionIcon
          size="sm"
          color="primary"
          style={{ borderColor: theme?.colors?.accent?.[6] }}
          variant="outline"
          onClick={() => {
            props.confirmActionResult(props.item, 'editar', true);
          }}
        >
          <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
        </ActionIcon>
      </Tooltip>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá o equipamento."
        variant="outline"
        onConfirm={() => {
          props.confirmActionResult(props.item, 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult(props.item, 'excluir', false);
        }}
      />
    </Group>
  );
}
